import { authSelectors } from 'app-components/flux/auth';
import { history } from 'app-components/utils/core';

import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper';
import { connectedReduxRedirect } from 'redux-auth-wrapper/history4/redirect';

export const userIsAuthenticatedWithDataset = connectedReduxRedirect({
  redirectPath: '/login',
  authenticatedSelector: authSelectors.isAuthenticatedWithDataSetId,
  authenticatingSelector: () => false,
  redirectAction: history?.replace,
  wrapperDisplayName: 'UserIsAuthenticatedWithDataset',
});

export const isAuthenticatedWithDatasetOrElse = (Component, ElseComponent) =>
  connectedAuthWrapper({
    authenticatedSelector: authSelectors.isAuthenticatedWithDataSetId,
    FailureComponent: ElseComponent,
    wrapperDisplayName: 'AuthenticatedWithDatasetOrElse',
  })(Component);

export const isAuthenticatedOrElse = (Component, ElseComponent) =>
  connectedAuthWrapper({
    authenticatedSelector: authSelectors.isAuthenticated,
    FailureComponent: ElseComponent,
    wrapperDisplayName: 'AuthenticatedOrElse',
  })(Component);
